// extracted by mini-css-extract-plugin
export default {"input-label-container":"FWmCx5FkM8MrBJy3WQ8w"};